import { Navigate, useLocation, useParams } from "react-router-dom";

export default function LegacyApplicationNotesRedirect() {
  const { applicationId } = useParams();
  const location = useLocation();

  return <Navigate to={`/people/membership-services/applications/${applicationId}/notes${location.search}`} replace />;
}
